<app-header></app-header>
@if (init) {
  <div>
    <router-outlet></router-outlet>
  </div>
}

<app-footer></app-footer>

